$(function () {
    $(document).on('click', '.import-from-file', function (event) {
        event.preventDefault();

        $(this).parent().find('input').click();
    });

    $(document).on('change', '#file', function (event) {
        event.preventDefault();

        $(this).parent('form').submit();
    });
})
